import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/LegalPage.css';

const LegalPage: React.FC = () => {
    useEffect(() => {
        // Vérifier les préférences pour le mode sombre et appliquer la classe dark au body
        const darkModeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

        const applyDarkMode = (e: MediaQueryListEvent) => {
            document.body.classList.toggle("dark", e.matches);
        };

        // Définir l'état initial du mode sombre
        document.body.classList.toggle("dark", darkModeMediaQuery.matches);

        // Ajouter un écouteur pour détecter les changements de thème
        darkModeMediaQuery.addEventListener("change", applyDarkMode);

        // Nettoyer l'écouteur lors de la destruction du composant
        return () => darkModeMediaQuery.removeEventListener("change", applyDarkMode);
    }, []);

    return (
        <div className="legal-page">
            {/* Titre principal */}
            <header>
                <h1 id="legal-title">Mentions Légales & CGV</h1>
            </header>

            <div className="legal-documents">
                {/* Section Mentions légales */}
                <section id="mentions-legales">
                    <h2>Mentions Légales</h2>
                    <h3>Éditeur du site</h3>
                    <p>
                        Nom du site : Vinomiam<br />
                        Adresse : 2 rue Kellermann, 59100 Roubaix, France<br />
                        Adresse email : millesimhall@gmail.com<br />
                        Numéro SIRET : 97833220300014<br />
                        Nom Commercial : MillésimHall
                    </p>

                    <h3>Hébergement</h3>
                    <p>
                        Le site est hébergé par :<br />
                        OVHcloud<br />
                        2 rue Kellermann, 59100 Roubaix, France
                    </p>

                    <h3>Responsabilité</h3>
                    <p>
                        Vinomiam est une application de conseil et vente de vin en ligne.<br />
                        Les liens vers les sites partenaires (PetitBallon.fr et Vinatis.com) sont fournis dans le cadre de partenariats.
                        Vinomiam ne peut être tenu responsable des erreurs d'achat, de transit, ou de tout problème lié aux services
                        proposés par ces sites partenaires.
                    </p>
                </section>

                {/* Section CGV */}
                <section id="conditions-generales">
                    <h2>Conditions Générales de Vente (CGV)</h2>

                    <h3>1. Objet</h3>
                    <p>
                        Les présentes Conditions Générales de Vente (CGV) régissent l'utilisation de l'application Vinomiam
                        et les relations contractuelles entre le site et ses utilisateurs.
                    </p>

                    <h3>2. Produits et services</h3>
                    <p>
                        Vinomiam propose :<br />
                        - Des recommandations personnalisées de vins.<br />
                        - Des liens vers des partenaires pour l'achat de vins (notamment PetitBallon.fr et Vinatis.com).<br />
                        Vinomiam agit uniquement en tant qu’intermédiaire pour ces achats et ne saurait être tenu responsable
                        des transactions réalisées sur ces sites partenaires.
                    </p>

                    <h3>3. Responsabilités</h3>
                    <p>
                        Vinomiam ne garantit pas l'exactitude ou la disponibilité des produits des partenaires. En cas de problème
                        (livraison, qualité du produit, remboursement, etc.), l’utilisateur doit contacter directement le site
                        partenaire concerné.
                    </p>

                    <h3>4. Prix et paiement</h3>
                    <p>
                        Les prix affichés sur le site partenaire sont sous leur seule responsabilité. Vinomiam ne facture aucun
                        service lié à ces transactions.
                    </p>

                    <h3>5. Protection des données</h3>
                    <p>
                        Vinomiam collecte des données dans le respect de la Politique de Confidentialité (voir ci-dessous).
                    </p>

                    <h3>6. Résiliation de l'accès</h3>
                    <p>
                        Vinomiam se réserve le droit de suspendre ou résilier l'accès à l'application en cas d'utilisation abusive
                        ou frauduleuse.
                    </p>

                    <h3>7. Droit applicable</h3>
                    <p>
                        Les présentes CGV sont régies par la loi française.
                    </p>
                </section>

                {/* Section Politique de confidentialité */}
                <section id="politique-confidentialite">
                    <h2>Politique de Confidentialité</h2>

                    <h3>1. Données collectées</h3>
                    <p>
                        Vinomiam collecte les données suivantes :<br />
                        - Adresse email des utilisateurs lors de l’inscription.<br />
                        - Données de consommation : préférences et types de vins consultés ou achetés via les partenaires.
                    </p>

                    <h3>2. Utilisation des données</h3>
                    <p>
                        Les données collectées sont utilisées pour :<br />
                        - Améliorer les recommandations personnalisées.<br />
                        - Effectuer des analyses statistiques sur les types de vins les plus consommés.
                    </p>

                    <h3>3. Partage des données</h3>
                    <p>
                        Les données collectées ne sont pas revendues à des tiers. Cependant, certaines données agrégées peuvent
                        être utilisées à des fins statistiques ou marketing.
                    </p>

                    <h3>4. Cookies</h3>
                    <p>
                        Le site utilise des cookies pour :<br />
                        - Analyser le trafic et améliorer l’expérience utilisateur.<br />
                        - Suivre les préférences des utilisateurs.<br />
                        Vous pouvez configurer votre navigateur pour refuser les cookies.
                    </p>

                    <h3>5. Droits des utilisateurs</h3>
                    <p>
                        Conformément au RGPD, vous disposez des droits suivants :<br />
                        - Accès, rectification, suppression des données personnelles.<br />
                        - Opposition à l’utilisation de vos données.<br />
                        Pour exercer vos droits, contactez : <a href="mailto:millesimhall@gmail.com">millesimhall@gmail.com</a>.
                    </p>
                    <h2>Contenus envoyés par les utilisateurs</h2>
                    <p>
                        Vinomiam permet aux utilisateurs d’envoyer des images dans le cadre de leurs échanges avec le chatbot. Ces images ne sont pas publiques et ne sont pas affichées à d’autres utilisateurs.
                    </p>

                    <p>
                        En tant qu’éditeur du service, Vinomiam agit en qualité d’hébergeur au sens de l’article 6 de la Loi n°2004-575 du 21 juin 2004 pour la confiance dans l’économie numérique (LCEN). À ce titre, Vinomiam n’est pas responsable a priori des contenus envoyés par les utilisateurs, et ne modère pas ces contenus de manière automatique.
                    </p>

                    <p>
                        Tout utilisateur est seul responsable des images qu’il envoie via la plateforme, et s’engage à ne pas transmettre de contenu illégal, choquant, violent, haineux, pornographique, ou portant atteinte aux droits d’autrui.
                    </p>

                    <p>
                        L’éditeur se réserve le droit de conserver les contenus litigieux à des fins de preuve en cas de litige, conformément à la législation en vigueur.
                    </p>

                </section>

            </div>

            {/* Bouton de retour */}
            <Link
                to="#"
                onClick={(e) => {
                    e.preventDefault(); // Empêche le comportement par défaut
                    window.history.back(); // Retourne à la page précédente
                }}
                className="back-button"
            >
                Retour
            </Link>
        </div>
    );
};

export default LegalPage;